import * as React from 'react';
import { CircularProgress, TextField, Typography } from '@mui/material';
import { DataAPIContext, GET_LIST } from '../../api';
import grey from '@mui/material/colors/grey';
import { makeStyles } from '@mui/styles';
import FilterListIcon from '@mui/icons-material/FilterList';

const useStyles = makeStyles((theme) => ({
    optionsMenu: {
        display: 'flex',
        maxHeight: '300px',
        maxWidth: '100%',
        width: '100%',
        overflowY: 'auto',
        flexDirection: 'column',
        backgroundColor: 'white',
        position: 'absolute',
        top: '3.75rem',
        borderRadius: '5px',
        left: 0,
        right: 0,
        zIndex: 1000,
        boxShadow: '0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)',
    },
    optionsGroupHeading: {
        marginLeft: '1rem',
        marginTop: '1rem',
        color: grey[600],
        fontSize: '80%',
    },
    optionItem: {
        width: '80%',
        cursor: 'pointer',
        paddingLeft: '1rem',
        paddingRight: '1rem',
        marginTop: '0.5rem',
        marginBottom: '0.5rem',
        zIndex: 10000,
    },
}));
const TripUserListRemoteAutocomplete = (props) => {
    const dataAPI = React.useContext(DataAPIContext);
    const [options, setOptions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [query, setQuery] = React.useState(null);
    const urlSuffix = props.urlSuffix === void 0 ? 'autocomplete/' : props.urlSuffix;
    const classes = useStyles();
    const [firstRender, setFirstRender] = React.useState(true);
    const [clearInput, setClearInput] = React.useState(false);

    React.useEffect(() => {
        if (clearInput) {
            props.setRecordListQuery(null);
            setClearInput(false);
            handleTextOnBlur();
            return;
        }

        props.setRecordListQuery(query);
        let active = true;
        const tm = setTimeout(async () => {
            setLoading(true);

            const params = {
                convert: props.convert,
                filter: { query: props.query || query, filters: undefined },
                urlSuffix: urlSuffix,
            };
            if (props.apiParams) {
                params.filter = { ...params.filter, ...props.apiParams };
            }
            if (props.apiFilters) {
                params.filter.filters = JSON.stringify(props.apiFilters);
            }
            const res = await dataAPI(GET_LIST, props.resource, params);
            if (active) {
                let sorted_filters = [...res.data];

                sorted_filters = sorted_filters.filter((sf) => sf.id !== 0);
                sorted_filters = sorted_filters.filter((sf) => sf.type !== 'travelers');

                let group_filters = [];
                group_filters = sorted_filters.filter((sf) => sf.type === 'group');
                group_filters.map((sf) => (sf.type = 'role'));
                if (!query || query === '' || query[0].toLowerCase() === 'g') {
                    sorted_filters = [{ id: null, name: 'Guest', type: 'role' }, ...sorted_filters];
                }
                setOptions(sorted_filters);

                if (!firstRender) {
                    setShowOptions(true);
                }
            }
            setLoading(false);
        }, 500);

        return () => {
            active = false;
            setFirstRender(false);
            clearTimeout(tm);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);

    const [showOptions, setShowOptions] = React.useState(false);

    const handleRoleFilterSelect = (role) => {
        let existingRoleFilter = props.recordListFilters.roleFilter?.filter((r) => r === role.id);
        if (existingRoleFilter?.length > 0) {
            let filterPlaceHolder = props.recordListFilters.roleFilter.filter((r) => r !== role.id);
            if (filterPlaceHolder?.length > 0) {
                props.setRecordListFilters((prevState) => ({ ...prevState, roleFilter: filterPlaceHolder }));
            } else {
                props.setRecordListFilters((prevState) => ({ ...prevState, roleFilter: null }));
            }
        } else {
            if (props.recordListFilters.roleFilter) {
                props.setRecordListFilters((prevState) => ({ ...prevState, roleFilter: [...prevState.roleFilter, role.id] }));
            } else {
                props.setRecordListFilters((prevState) => ({ ...prevState, roleFilter: [role.id] }));
            }
        }

        props.setLastUpdate(new Date().toString());
    };

    const handleAddSearchFilter = (ev, option) => {
        ev.preventDefault();
        if (option.type === 'role') {
            handleRoleFilterSelect(option);
        }

        // remove slashes since they are being added to the URL
        option.name = option?.name?.replace(/\//g, '')
        props.onChange && props.onChange(ev, option);

        setClearInput(true);
        setQuery('');
    };

    const handleTextOnBlur = (ev) => {
        setTimeout(() => {
            setShowOptions(false);
        }, 300);
    };

    const getTagDisplayName = (tag) => {
        if (!tag || tag.type !== 'tag') {
            return tag?.name || tag?.email || '';
        }

        let categoryName = null;
        
        if (tag.category?.name) {
            categoryName = tag.category.name;
        } else if (props.trip?.tag_categories && tag.category_id) {
            const category = props.trip.tag_categories.find(
                (tc) => tc.category.id === tag.category_id
            );
            if (category) {
                categoryName = category.category.name;
            }
        } else if (props.trip?.tag_categories && tag.category?.id) {
            const category = props.trip.tag_categories.find(
                (tc) => tc.category.id === tag.category.id
            );
            if (category) {
                categoryName = category.category.name;
            }
        }

        if (categoryName) {
            return `${categoryName}: ${tag.name}`;
        }
        
        return tag.name || '';
    };

    let userOptionsGroup = options.length > 0 && options.filter((option) => option.type === 'user');
    let tagsOptionsGroup = options.length > 0 && options.filter((option) => option.type === 'tag');
    return (
        <>
            {/* Fill the column only. A viewport-wide box (z-index 1000) used to
                cover the phone [+] and Export, so a tap focused this field (CP-8379). */}
            <div style={{ width: '100%', maxWidth: '100%', minWidth: 0, display: 'flex', alignItems: 'center', position: 'relative' }}>
                <>
                    <TextField
                        color="primary"
                        size="small"
                        variant="filled"
                        label={props.label}
                        fullWidth
                        value={query || ''}
                        onClick={(ev) => setShowOptions(true)}
                        onBlur={handleTextOnBlur}
                        onChange={(ev) => setQuery(ev.target.value)}
                        InputProps={{
                            endAdornment: <React.Fragment>{loading ? <CircularProgress color="primary" size={20} /> : null}</React.Fragment>,
                        }}
                    />

                    {showOptions && (
                        <div className={classes.optionsMenu}>
                            {userOptionsGroup.length > 0 && (
                                <div className={classes.optionsGroupHeading}>
                                    <Typography>Users</Typography>
                                </div>
                            )}
                            {userOptionsGroup.length > 0 &&
                                userOptionsGroup.map((option) => {
                                    return (
                                        <div key={option.id || option.email} className={classes.optionItem} onClick={(ev) => handleAddSearchFilter(ev, option)}>
                                            <Typography>{option.name || option.email}</Typography>
                                        </div>
                                    );
                                })}
                            {tagsOptionsGroup.length > 0 && (
                                <div className={classes.optionsGroupHeading}>
                                    <Typography>Tags</Typography>
                                </div>
                            )}
                            {tagsOptionsGroup.length > 0 &&
                                tagsOptionsGroup.map((option) => {
                                    return (
                                        <div key={option.id || option.name} className={classes.optionItem} onClick={(ev) => handleAddSearchFilter(ev, option)}>
                                            <Typography>{getTagDisplayName(option)}</Typography>
                                        </div>
                                    );
                                })}
                            {options && options.length < 1 && (
                                <div style={{ padding: '1rem' }}>
                                    <Typography>No matches found.</Typography>
                                </div>
                            )}
                        </div>
                    )}
                </>
                {props.searchFilterList.length > 0 && props.isSmallScreen && (
                    <div onClick={(ev) => props.showSearchFilters(ev.target)} style={{ paddingLeft: '0.5rem', width: '2rem' }}>
                        <FilterListIcon style={{ fontSize: '2rem' }} color="primary" />
                    </div>
                )}
            </div>
        </>
    );
};

export default TripUserListRemoteAutocomplete;
